module.exports = __webpack_public_path__ + "img/35.c77a5dff.png";